<template>
  <div>
    <h1>Die Termine für die nächsten 356 Tage:</h1>
    <br>
    <b-table
      :items="events"
      :fields="fields"
      responsive
      show-empty
      :busy="false"
    >
      <template #cell(name)="data">
        {{ data.item.c_title }}
      </template>

      <template #cell(start)="data">
        {{ unixTimestampToString(data.item.c_startdate) }}
      </template>

      <template #cell(end)="data">
        {{ unixTimestampToString(data.item.c_enddate) }}
      </template>

      <template #cell(description)="data">
        {{ data.item.c_description }}
      </template>

      <template #empty>
        Für diesen Monat gibt es keine Termine
      </template>

      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle" />
          <strong> Laden...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CalendarList',
  data () {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'start',
          label: 'Start'
        },
        {
          key: 'end',
          label: 'Ende'
        },
        {
          key: 'description',
          label: 'Beschreibung'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('config', [
      'getConfig',
      'configIsLoaded'
    ]),
    ...mapGetters('logineoCalendar', {
      events: 'getEvents'
    }),
    config () {
      return this.getConfig
    }
  },
  watch: {
    'this.config': function () {
      console.error('config Change')
      this.fetchEvents()
    }
  },
  mounted () {
    this.fetchEvents()
  },
  methods: {
    ...mapActions('logineoCalendar', [
      'fetchEvents'
    ]),
    unixTimestampToString (unixTimestamp) {
      const date = new Date(unixTimestamp)
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      const hour = ('0' + date.getHours()).slice(-2)
      const min = ('0' + date.getMinutes()).slice(-2)

      return day + '.' + month + '.' + date.getFullYear() + ' ' + hour + ':' + min
    }
  }
}
</script>

<style scoped>

</style>
